import H from 'history';
import { createContext, useContext } from 'react';

import { mediaSize } from '~/src/dash/components/layout/common';
import { IStore } from '~/src/dash/reducers/store';

interface IMobileStore extends IStore {
  location: H.Location;
  isSuperUser: boolean;
  children: any;
  [key: string]: any;
}

export const MobileContext = createContext({} as IMobileStore);
export const useMobileStore = () => useContext(MobileContext);

export interface IMobileState {
  totalWidth: number | null;
  totalHeight: number | null;
  mediaSize: mediaSize;
}

export const MobileContextState = createContext({} as IMobileState);
export const useMobileState = () => useContext(MobileContextState);

export const MobileConfig = createContext({} as any);
export const useMobileConfig = () => useContext(MobileConfig);
